export { default as CellWithInfoIcon } from './src/cell-with-info-icon';
